import environment from "./base";
const baseApi = "https://edify-api-dev.edify.la";
const authApi = "https://edify-api-dev.edify.la";

const env = environment(baseApi, authApi);
const developmentConfig = {
  ...env,
  intervals: {
    ...env.intervals,
    logout: 1800, // 30 min in seconds
  },
  appUrl: 'https://test.app.edify.la',
  marketplace: {
    url: 'https://test.market.edify.la',
  },
  isProduction: false,
  isDevelopment: true,
  env: "development",
  SENTRY_DSN:
    "https://d575f30ee6453e7391f4a6324db5b891@o4510264577818624.ingest.us.sentry.io/4510264581881856",
  googleMaps: {
    apiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY,
  },
  googleOAuth: {
    clientId: process.env.REACT_APP_GOOGLE_CLIENT_ID,
  },
  mercadoPago: {
    publicKey: "TEST-29c2c6a6-8092-447a-8b33-803930bb6fa6",
    clientId: "8639587373625884", 
    redirectUri: "https://test.app.edify.la/documentacion-de-obra/oauth-callback", 
    sandbox: true,
  },
  firebase: {
    apiKey: "AIzaSyC1837T9gKotAG9D0KLGtvA40yo2Pi1MOo",
    authDomain: "edify-firebase-test.firebaseapp.com",
    projectId: "edify-firebase-test",
    storageBucket: "edify-firebase-test.firebasestorage.app",
    messagingSenderId: "394112989092",
    appId: "1:394112989092:web:8468625ba729211cab7331",
    measurementId: "G-5T3CE63QM9",
  },
  turnstile: {
    siteKey: "0x4AAAAAACbPi-FmiZpUmDn8",
  },
};

export default developmentConfig;
